export const MIN_WIDTH = 200;

export const ICONS = {
  Folder: '📁',
  Article: '📄',
  Picture: '🖼️',
  Teaser: '📝',
  Video: '🎬',
  'Checked In': '🔒',
  'Checked Out': '🔓',
  Approved: '✔️',
  Published: '🌍',
  Deleted: '❌',
}; 